module.exports = __webpack_public_path__ + "img/jiker.com-green-logo.74103fd9.png";